import { createRef, Fragment, useEffect } from 'react';

import { ChevronUpIcon } from '@zola/zola-ui/src/components/SvgIconsV3/ChevronUp';

import _throttle from 'lodash/throttle';

const scrollToTop = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

const SHOW_SCROLL_BUTTON_Y_BREAK = 500;

export const ScrollToTopButton: React.FC = ({ children }) => {
  const scrollButton = createRef<HTMLButtonElement>();

  useEffect(() => {
    const setScrollButtonVisibility = _throttle(() => {
      if (scrollButton.current) {
        if (window.pageYOffset > SHOW_SCROLL_BUTTON_Y_BREAK) {
          scrollButton.current.style.opacity = '1';
        } else {
          scrollButton.current.style.opacity = '0';
        }
      }
    }, 500);

    window.addEventListener('scroll', setScrollButtonVisibility);

    return () => {
      window.removeEventListener('scroll', setScrollButtonVisibility);
    };
  }, [scrollButton]);

  return (
    <Fragment>
      {children}
      <button
        id="back-to-top-button"
        aria-label="Back To Top"
        ref={scrollButton}
        onClick={scrollToTop}
      >
        <ChevronUpIcon showTitle={false} height={24} width={24} />
      </button>
    </Fragment>
  );
};
